<template>
  <mu-card id="ketones-input">
    <mu-card-text class="card-style" v-bind:class="{cardHasData: hasData}">
      <div v-if="loading">
        <mu-flexbox class="card-loading-padding" align="center" justify="center">
          <mu-flexbox-item align="center">
            <mu-circular-progress :size="56" color="#FFFFFF" :strokeWidth="5"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>
      <div v-if="!loading" class="animated fadeIn">
        <mu-flexbox v-if="data.no_setting || data.error" class="card-error-padding" justify="center">
          <mu-flexbox-item align="center">
            <div class="card-notice-title">{{$t('message.cardEmpty')}}</div>
            <div>{{$t('message.cardTapPrefix')}}
              <mu-icon v-if="data.no_setting" class="card-icon-error" :size="16" slot="left" value="settings"/>
              <mu-icon v-if="data.error" class="card-icon-error" :size="16" slot="left" value="add"/>
              <span v-if="data.error || data.no_setting">{{$t('message.cardTapSuffix')}}</span>
            </div>
          </mu-flexbox-item>
        </mu-flexbox>
        <div v-else @click="goToDetail" style="cursor: pointer;">
          <span v-show="false">{{hasData = true}}</span>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">
                <span v-text="latestReadingTitle"></span>
              </mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div class="card-large-stat">
                  <span v-text="data.latest_value + ' ' + bloodGlucose.unit"></span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox v-if="data.last_occurrence">
              <mu-flexbox-item class="card-lite-title">
                <span v-text="lastOccurrenceTitle"></span>
              </mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="formatDate(data.last_occurrence)"/>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">
                <span v-text="totalOccurrenceTitle"></span>
              </mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.total_occurrence"/>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
        </div>
      </div>
    </mu-card-text>
    <mu-card-actions>
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="17px" height="15px" viewBox="20 193 17 15" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <!-- Generator: Sketch 39.1 (31720) - http://www.bohemiancoding.com/sketch -->
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <path
          <path
            d="M27.596657,204.024078 L27.4483433,202.008701 C27.4466257,202.00863 27.4449084,202.008558 27.4431913,202.008486 C27.1065685,201.994308 26.7913774,201.899106 26.5165508,201.742332 C26.5127922,201.740187 26.5090412,201.738031 26.5052978,201.735864 L22.9607307,205.098641 C22.9022004,205.00058 22.8320228,204.910144 22.7520541,204.829189 C22.8320477,204.91017 22.9022218,205.000584 22.9607307,205.098603 C23.0858378,205.308123 23.1578576,205.552244 23.1578576,205.813086 C23.1578576,206.591273 22.5192209,207.222113 21.7315461,207.222113 C20.9438714,207.222113 20.3052347,206.591273 20.3052347,205.813086 C20.3052347,205.034899 20.9438714,204.404059 21.7315461,204.404059 C22.0081146,204.404059 22.266129,204.482054 22.4847255,204.616683 C22.5823877,204.676827 22.6721283,204.748294 22.7520786,204.829222 C22.6721112,204.74826 22.5823835,204.676806 22.4847255,204.616683 L25.9804623,201.300249 C25.979853,201.299539 25.9792442,201.298829 25.9786358,201.298118 C25.8510297,201.149012 25.7450446,200.981427 25.6654138,200.799813 C25.6638728,200.796296 25.6623417,200.792774 25.6608205,200.789247 L23.7310234,201.083431 C23.731024,201.083445 23.7310246,201.08346 23.7310252,201.083474 C23.7316689,201.099335 23.7322369,201.115233 23.7322369,201.131281 C23.7322369,201.754564 23.2207519,202.259789 22.5899154,202.259789 C21.9590789,202.259789 21.447594,201.754564 21.447594,201.131281 C21.447594,200.508035 21.9590789,200.002773 22.5899154,200.002773 C23.0588019,200.002773 23.4615755,200.282057 23.6375736,200.681344 C23.6649255,200.743352 23.6867798,200.808249 23.70255,200.875451 C23.686733,200.808242 23.6648749,200.743329 23.6375357,200.681307 L25.5370166,200.391763 C25.5120013,200.265875 25.498617,200.135916 25.498617,200.002773 C25.498617,199.791682 25.531787,199.588223 25.5929395,199.397109 C25.594108,199.393456 25.5952868,199.389807 25.5964758,199.386163 L22.2313526,197.296404 C22.0022118,197.451577 21.7251049,197.542657 21.4263115,197.542657 C20.6386368,197.542657 20,196.911817 20,196.13363 C20,195.355443 20.6386368,194.724603 21.4263115,194.724603 C22.2139862,194.724603 22.852623,195.355443 22.852623,196.13363 C22.852623,196.360693 22.7979454,196.575001 22.701351,196.764993 C22.6977556,196.772067 22.6941018,196.779107 22.6903901,196.786113 L25.9134096,198.787653 C25.9142237,198.786597 25.9150389,198.785541 25.9158551,198.784487 C26.1606166,198.468319 26.498224,198.226405 26.8885399,198.097948 C26.8904269,198.097326 26.8923151,198.096707 26.8942045,198.096091 L26.5419267,196.272088 C26.5275843,196.272616 26.5131743,196.272881 26.4987015,196.272881 C26.0241731,196.272881 25.6173101,195.986976 25.4447199,195.580058 C25.3919735,195.455716 25.3614161,195.320001 25.3572131,195.177778 C25.3569102,195.166631 25.35638,195.155558 25.35638,195.144373 C25.35638,194.521128 25.867865,194.015865 26.4987015,194.015865 C27.129538,194.015865 27.641023,194.521128 27.641023,195.144373 C27.641023,195.609839 27.3557657,196.009462 26.9485713,196.181993 L27.3011865,198.00799 C27.302338,198.007862 27.3034899,198.007735 27.3046421,198.007609 C27.3790096,197.999454 27.4544752,197.99489 27.5310768,197.99489 C27.8205573,197.99489 28.0956868,198.055079 28.3449164,198.162849 C28.3489893,198.16461 28.3530551,198.166383 28.3571139,198.168169 L31.3242218,194.710288 C31.295779,194.66368 31.2706485,194.614875 31.2491522,194.564193 C31.1964058,194.43985 31.1658485,194.304136 31.1616454,194.161913 C31.1613425,194.150766 31.1608124,194.139693 31.1608124,194.128508 C31.1608124,193.505263 31.6722974,193 32.3031339,193 C32.9339704,193 33.4454553,193.505263 33.4454553,194.128508 C33.4454553,194.751791 32.9339704,195.257016 32.3031339,195.257016 C32.1358821,195.257016 31.9770362,195.221499 31.8338911,195.157684 L28.927578,198.544676 C28.9281876,198.545247 28.9287969,198.545817 28.9294058,198.546388 C29.2396504,198.837192 29.4568592,199.223451 29.533072,199.657709 L31.5322182,199.230597 C31.5317163,199.221318 31.5313269,199.21201 31.5310509,199.202673 C31.530748,199.191526 31.5302179,199.180453 31.5302179,199.169268 C31.5302179,198.546023 32.0417029,198.04076 32.6725394,198.04076 C33.3033759,198.04076 33.8148608,198.546023 33.8148608,199.169268 C33.8148608,199.792551 33.3033759,200.297776 32.6725394,200.297776 C32.2080875,200.297776 31.8084578,200.023885 31.6298678,199.63071 L29.5619371,200.072526 C29.5617913,200.076347 29.5616419,200.080166 29.5614918,200.083984 C29.5475952,200.428133 29.4461919,200.749912 29.2784484,201.028261 C29.2780899,201.028856 29.277731,201.02945 29.2773718,201.030045 L33.6347039,203.867711 C33.4627953,204.016368 33.3274646,204.205164 33.2434793,204.419359 L28.8313211,201.546008 C28.8277765,201.548928 28.8242216,201.551836 28.8206565,201.554733 C28.5521534,201.772744 28.2259435,201.923646 27.8681919,201.982675 C27.8668152,201.982902 27.865438,201.983128 27.8640604,201.983353 L28.0113579,203.984385 C28.5960015,204.0338 29.0550808,204.51804 29.0550808,205.108442 C29.0550808,205.731725 28.5435959,206.23695 27.9127594,206.23695 C27.2819229,206.23695 26.7704379,205.731725 26.7704379,205.108442 C26.7704379,204.593604 27.1195928,204.159566 27.5966568,204.024075 Z M27.9622524,203.981169 C27.9787073,203.981941 27.995072,203.983055 28.0113607,203.984422 Z M34.5736885,203.518774 C34.2140057,203.518774 33.8856375,203.650598 33.6347039,203.867711 C33.4627953,204.016443 33.3274646,204.205164 33.2434793,204.419396 C33.1816452,204.577181 33.147377,204.748507 33.147377,204.927838 C33.147377,205.706026 33.7860138,206.336865 34.5736885,206.336865 C35.3613632,206.336865 36,205.706026 36,204.927838 C36,204.149651 35.3613632,203.518774 34.5736885,203.518774 Z"
            id="Combined-Shape" stroke="none" fill="#2761ff" fill-rule="evenodd"></path>
        </svg>
        <mu-flexbox-item class="left16" v-text="loading ? $t('message.loadingText') : title"></mu-flexbox-item>
        <mu-flexbox-item align="right" v-bind:class="{invisible: isOpen}">

          <mu-icon-button
            :disabled="loading"
            v-tooltip.top="$t('message.addEntryText')"
            v-if="bloodGlucose !== false && isOpenInput === false"
            class="card-bar-icon"
            :icon="'add'"
            @click.native="openInput"
          ></mu-icon-button>

          <mu-icon-button
            :disabled="loading"
            v-if="bloodGlucose !== false && isOpenInput === true"
            class="card-bar-icon"
            :icon="'remove'"
            @click.native="openInput"
          ></mu-icon-button>

          <mu-icon-button
            :disabled="loading"
            v-if="bloodGlucose === false"
            class="card-bar-icon"
            icon="settings_cog"
            @click.native="goToSettings()"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>

    <transition :css="false" @enter="onToggleEnter" @leave="onToggleLeave">
      <form @submit.prevent="saveReading" v-if="isOpenInput" novalidate v-bind:style="{height: computedAuto}"
            style="overflow: hidden">
        <mu-card-text>
          <mu-row>
            <mu-col width="100" tablet="50" desktop="50" v-if="bloodGlucose.measure === 'mgdl'">
              <mu-text-field
                type="number"
                v-validate
                min="0"
                max="63"
                data-vv-validate-on="none"
                :data-vv-rules="'required|min_value:0|max_value:63'"
                data-vv-name="ketones_mgdl"
                :data-vv-value-path="inputValue"
                :data-vv-as="bloodGlucose.unit"
                :errorText="errors.first('ketones_mgdl')"
                :label="$t('message.cardKetones')"
                v-model.number="model.mgdl"
                :hintText="$t('message.placeholderText')"
                :fullWidth="true"
                :helpText="bloodGlucose.unit"
              />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50" v-if="bloodGlucose.measure === 'mmoll'">
              <mu-text-field
                type="number"
                v-validate
                min="0.1"
                max="3.5"
                data-vv-validate-on="none"
                :data-vv-rules="'required|min_value:0|max_value:3.5'"
                data-vv-name="ketones_mmoll"
                data-vv-value-path="inputValue"
                :data-vv-as="bloodGlucose.unit"
                :errorText="errors.first('ketones_mmoll')"
                :label="$t('message.cardKetones')"
                v-model="model.mmoll"
                :hintText="$t('message.placeholderText')"
                :fullWidth="true"
                :helpText="bloodGlucose.unit"
              />
            </mu-col>
          </mu-row>
          <div class="bottom"></div>
          <mu-checkbox v-model="model.customDate" :label="$t('message.labelCustomDate')"></mu-checkbox>
          <date-picker v-if="model.customDate" type="datetime" v-model="model.date"></date-picker>
        </mu-card-text>
        <mu-card-actions align="right">
          <button type="submit" style="display: none"></button>
          <mu-flat-button
            :label="$t('message.discardText')"
            @click.native="closeInput"
            class="demo-flat-button"
          />
          <mu-flat-button
            @click.native="saveReading"
            :disabled="isSaving"
            :label="isSaving ? $t('message.savingText'): $t('message.saveText')"
            class="demo-flat-button"
          />
        </mu-card-actions>
      </form>
    </transition>

  </mu-card>
</template>
<script>

  import { TweenMax, TweenLite, Power3, ScrollToPlugin } from 'gsap/all'
  import 'gsap/ScrollToPlugin'
  const plugins = [ ScrollToPlugin];

  import KetonesApi from '../../../../api/Tracking/Ketones'
  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import CardAnimationMixin from '../../../../mixins/CardAnimationMixin'
  import DatePicker from "../../../DateTimePicker/DateTimePicker.vue";

  export default {
    name: 'ketones-input',
    mixins: [ScrollerMixin, CardAnimationMixin],
    components: {DatePicker},
    props: {
      bloodGlucose: {}
    },
    data() {
      return {
        latestReadingTitle: "",
        lastOccurrenceTitle: "",
        totalOccurrenceTitle: "",
        title: this.$t('message.cardKetones'),
        isOpen: false,
        isOpenInput: false,
        isSaving: false,
        hasData: false,
        loading: true,
        data: {},
        model: {}
      }
    },
    created() {
      let self = this;
      self.latestReadingTitle = self.$store.state.i18n.t('message.cardLatestReading');
      self.lastReadingAtTitle = self.$store.state.i18n.t('message.cardLatestReadingAt');
      self.lastOccurrenceTitle = self.$store.state.i18n.t('message.cardKetonesLastOccurrence');
      self.totalOccurrenceTitle = self.$store.state.i18n.t('message.cardKetonesTotalOccurrences');
    },
    mounted() {
      let self = this;
      self.loadData();

      self.$EventBus.$on('ketonesPusherReceived', function (model) {
        self.$nextTick(function () {
          self.data = model;
          self.$forceUpdate();
        });
      });

      self.$EventBus.$on('ketonesReadingUpdated', function () {
        self.$store.commit('setKetonesCard', {});
        self.loadData();
      });

      self.$EventBus.$on('lc:settingsUpdated', function () {
        self.loadData();
      });
    },
    methods: {
      formatDate(date) {
        return moment(date).subtract(30, 'seconds').fromNow()
      },
      saveReading() {
        let self = this;
        self.isSaving = true;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {

              if (!_.has(self.model, 'date')) {
                self.model.date = moment().format();
              }

              KetonesApi.postKetonesTracking(self.model)
                .then(function (response) {
                  self.$store.commit('setKetonesCard', {});
                  self.$gtag.event('ReadingAdded',{
                    'event_category': 'KetonesCard',
                    'event_label': 'Added reading',
                    'value': 1
                  });
                  self.isSaving = false;

                  if (self.$route.name === 'Dashboard') {
                    TweenLite.to(self.scroller, 0.2, {
                      scrollTo: {
                        y: self.$el,
                        offsetY: 16
                      }
                    })
                  }
                  self.$toastr.success(self.$t('message.cardKetonesAdded'));
                  self.$EventBus.$emit('ketonesReadingAdded');
                  self.$EventBus.$emit('updateGraph');
                  self.loadData()
                })
                .catch(function () {
                  self.isSaving = false;
                  self.loadData()
                })
            }
            else {
              self.isSaving = false;
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      closeInput() {
        let self = this;
        self.isOpenInput = false;

        self.$gtag.event('Closed',{
          'event_category': 'KetonesCard',
          'event_label': 'Closed card',
          'value': 0
        });

        self.model = {}
      },
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;

        if (self.isOpenInput === true) {
          self.$gtag.event( 'Open',{
            'event_category': 'KetonesCard',
            'event_label': 'Opened card',
            'value': 0
          });
        }
        if (!self.isOpenInput) {
          self.$gtag.event('Closed',{
            'event_category': 'KetonesCard',
            'event_label': 'Closed card',
            'value': 0
          });
        }
        self.model = {}
      },
      loadData() {
        let self = this;
        self.loading = true;
        self.isOpenInput = false;
        self.model = {};

        /**
         * Check if vuex store exists for ketones card, else load from server
         */
        if (_.has(self.$store.state.cards.ketones, 'ketoacidosis')) {
          self.data = self.$store.state.cards.ketones;
          self.loading = false;
        }
        else {
          KetonesApi.getKetonesTrackingCard()
            .then(function (response) {
              const status = response.status;
              if (status === 200) {
                self.data = response.data;
                self.$store.commit('setKetonesCard', response.data);
                self.loading = false
              }
              else {
                if (status === 201) {
                  self.data = response.data;
                  self.loading = false;
                }
              }
            })
        }
      },
      goToSettings() {
        let self = this;
        self.$router.push({
          name: 'SettingsUnits'
        })
      },
      goToDetail() {
        let self = this;
        self.$router.push({
          path: '/tracking/ketones/'
        })
      },
      decimalize(num) {
        if (isNaN(num)) {
          return 0;
        }
        let number = numeral(num);
        if (this.isWholeNumber(num)) {
          return number.format('0');
        }
        return number.format('0.0');
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('ketonesReadingUpdated');
      this.$EventBus.$off('ketonesPusherReceived');
    }
  }
</script>
<style lang="less">
  @import "./ketones.less";
</style>



// WEBPACK FOOTER //
// Ketones.vue?0886f798